import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';

import { DefaultPopup } from '@atlas/ui';

import ModalPortal from 'common/ModalPortal/ModalPortal';

const PaymentIframe = ({ paymentUrl, setPaymentUrl }) => {
  const onClose = useCallback(() => {
    setPaymentUrl(null);
  }, [setPaymentUrl]);

  useEffect(() => {
    const messageHandler = event => {
      if (event.origin === window.location.origin) {
        if (event.data === 'closePaymentPopup') {
          onClose();
        }
      }
    };
    window.addEventListener('message', messageHandler);

    return () => {
      window.removeEventListener('message', messageHandler);
    };
  }, [onClose]);

  return (
    <ModalPortal>
      <DefaultPopup headerTitle="Deposit" headerTitlePosition="left" onClose={onClose}>
        <div className="payment-item-container">
          <div className="payment-iframe-container">
            <iframe src={paymentUrl} />
          </div>
        </div>
      </DefaultPopup>
    </ModalPortal>
  );
};

PaymentIframe.propTypes = {
  paymentUrl: PropTypes.string.isRequired,
  setPaymentUrl: PropTypes.func.isRequired,
};

export default PaymentIframe;
